module.exports = __webpack_public_path__ + "static/Bild Seite 1 - Verkäuferin-7b5763b82ece4363c86cfffd584e819d.jpg";